// Enterprise tile used by /admin (Manage grid), /admin/warehouse, and
// /admin/hardware. Deliberately not extending the existing
// home-card / admin-card patterns — those are shared with the basic
// Home page and we want a dedicated, restrained admin look (subtle
// border, orange focus ring, hover, optional one-line description).
import { Link } from "react-router-dom";
import { ReactNode } from "react";
import { useTranslation } from "../../i18n";

export type AdminTileTone = "orange" | "blue" | "teal" | "purple" | "green" | "amber" | "slate";

interface AdminTileProps {
    to: string;
    labelKey: string;
    descriptionKey?: string;
    icon: ReactNode;
    /** Colour accent applied to the icon chip. Defaults to neutral grey. */
    tone?: AdminTileTone;
    /** Dense variant for long grids (the Warehouse menu): icon chip
     *  beside the label, smaller type, no minimum height. Styled by
     *  .admin-home-tile--compact in admin-home.css. */
    compact?: boolean;
}

const AdminTile = ({ to, labelKey, descriptionKey, icon, tone, compact }: AdminTileProps) => {
    const { t } = useTranslation();
    return (
        <Link to={to} className={`admin-home-tile${compact ? " admin-home-tile--compact" : ""}`}>
            <span className={`admin-home-tile-icon${tone ? ` admin-home-tile-icon--${tone}` : ""}`}>
                {icon}
            </span>
            <span className="admin-home-tile-label">{t(labelKey)}</span>
            {descriptionKey && (
                <span className="admin-home-tile-desc">{t(descriptionKey)}</span>
            )}
        </Link>
    );
};

export default AdminTile;
